import {
  capitalize,
  unstable_composeClasses as composeClasses,
  generateUtilityClass,
  generateUtilityClasses
} from "@mui/material";
const actionBarName = "TidalActionBar";
function getActionBarUtilityClass(slot) {
  return generateUtilityClass(actionBarName, slot);
}
const actionBarClasses = generateUtilityClasses(actionBarName, [
  "root",
  "sizeSmall",
  "sizeMedium",
  "sizeLarge",
  "list",
  "listTextOnly",
  "listTextIcon",
  "listIconOnly",
  "menuButton",
  "menuTooltip",
  "menuTextOnly",
  "menuTextIcon",
  "menuIconOnly",
  "truncateList",
  "popper",
  "stack"
]);
function useUtilityClasses(ownerState) {
  const { size, menuMode, classes, listMode } = ownerState;
  const slots = {
    list: ["list", menuMode && `menuMode${capitalize(menuMode)}`, listMode && `listMode${capitalize(listMode)}`],
    menuButton: ["menuButton"],
    menuTooltip: ["menuTooltip"],
    popper: ["popper"],
    root: ["root", size && `size${capitalize(size)}`],
    stack: ["stack"],
    truncateList: ["truncateList"]
  };
  return composeClasses(slots, getActionBarUtilityClass, classes);
}
export {
  actionBarClasses,
  actionBarName,
  getActionBarUtilityClass,
  useUtilityClasses
};
//# sourceMappingURL=classes.js.map
